import { useI18n } from "@/lib/i18n";

const logos = [
  "ARMATEC AG", "Helvetia Mechanik", "MedTech Suisse", "Schilthorn Werke",
  "Rheintal Industrie", "Aera Aerospace", "Engadin Bau", "Sigma Hydraulik",
  "Walliser Apparate", "Tessin Optik", "Glarner Stahl", "Bodensee Tech",
];

const COPY = {
  de: {
    overline: "— Vertrauen seit Jahrzehnten",
    title_1: "Industrielle Partner aus",
    title_2: "Schweiz und Liechtenstein.",
    note: "Auswahl, anonymisiert · Referenzen auf Anfrage.",
  },
  en: {
    overline: "— Trusted for decades",
    title_1: "Industrial partners from",
    title_2: "Switzerland and Liechtenstein.",
    note: "Anonymised selection · references on request.",
  },
  fr: {
    overline: "— Une confiance bâtie sur des décennies",
    title_1: "Des partenaires industriels de",
    title_2: "Suisse et du Liechtenstein.",
    note: "Sélection anonymisée · références sur demande.",
  },
  it: {
    overline: "— Fiducia da decenni",
    title_1: "Partner industriali da",
    title_2: "Svizzera e Liechtenstein.",
    note: "Selezione anonimizzata · referenze su richiesta.",
  },
};

export const LogoWall = () => {
  const { lang } = useI18n();
  const c = COPY[lang] || COPY.de;
  const row = [...logos, ...logos];
  return (
    <section
      data-testid="logos-section"
      className="relative bg-[#0E0E10] py-20 md:py-28 border-t border-white/5"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 mb-10 md:mb-14">
        <div className="overline reveal mb-4">{c.overline}</div>
        <h2 className="reveal reveal-delay-1 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1] text-white max-w-3xl">
          {c.title_1}
          <br />
          <span className="text-zinc-500">{c.title_2}</span>
        </h2>
      </div>

      <div className="relative overflow-hidden">
        <div className="flex w-max marquee-track items-center">
          {row.map((name, i) => (
            <div
              key={`${name}-${i}`}
              className="flex-none px-8 md:px-12 py-4 border-r border-white/5"
            >
              <div className="flex items-center gap-3 opacity-50 hover:opacity-100 transition-opacity duration-500">
                <div className="w-9 h-9 border border-white/20 flex items-center justify-center font-display font-semibold text-[12px] tracking-tight text-white">
                  {name.split(" ").map((w) => w[0]).slice(0, 2).join("")}
                </div>
                <span className="font-display text-base md:text-lg tracking-tight text-zinc-300 whitespace-nowrap">
                  {name}
                </span>
              </div>
            </div>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#0E0E10] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#0E0E10] to-transparent" />
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-10 mt-10 text-[12px] text-zinc-500">
        {c.note}
      </div>
    </section>
  );
};

export default LogoWall;
